/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const other_services : {[key: string]: Array<[string, string]>} = {
};
